module.exports = __webpack_public_path__ + "static/media/landscape.81f97d00.jpg";